export const scrollToElement = (id: string): void => {
	document.getElementById(id)?.scrollIntoView({
		behavior: "smooth",
	});
};

export const scrollToTop = (n?: number): void => {
	window.scrollTo({
		top: n ?? 0,
		behavior: "smooth",
	});
};

export function scrollIntoView(elem: HTMLElement | null): void {
	elem?.scrollIntoView({behavior: "smooth", block: "nearest"});
}
